import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginatedRepository } from '../../../services/pagination/paginated.repository';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../../reg-hub-common-config';
import { PricingComparisonReport } from '../../../interfaces/reports/pricing-comparison-report';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PricingComparisonReportRepositoryService {

    private _baseLink: string;
    protected _currentParams: HttpParams = new HttpParams();

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
        private http: HttpClient,
        messageService: ToastrService) {
        this._baseLink = `${config.rootUrl}/Reports/PricingComparison`;
  }

  public clearFilters() {
        this._currentParams = new HttpParams();
    }

    private setParam(key: string, value: string | number | boolean) {
        this._currentParams = this._currentParams.set(key, value);
    }

    private clearParam(key: string) {
        this._currentParams = this._currentParams.delete(key);
    }

    public getReportData(params: HttpParams): Observable<PricingComparisonReport[]> {
        return this.http.get<PricingComparisonReport[]>(this._baseLink, { params: params });
    }
}
